/** Tag Assistant follows a link into a new tab only when its Chrome extension is
 * installed AND the `__TAG_ASSISTANT` cookie exists. GTM's debug bootstrap sets that
 * cookie itself only when the extension is absent, so with the extension every
 * target="_blank" card click dropped the debug session ("GTM-PTHJV3S not found").
 * Set the cookie here whenever the page carries a fresh Tag Assistant debug signal. */
const COOKIE = "__TAG_ASSISTANT";
/** Not refreshed by the site; restart the Tag Assistant session after this. */
const MAX_AGE_S = 60 * 60;
/** Same freshness window gtm.js applies to `gtm_debug` (a ms timestamp). */
const MAX_PAST_MS = 15 * 60 * 1000;
const MAX_FUTURE_MS = 5 * 60 * 1000;

/** Inline <head> script; must run before the GTM snippet so the cookie exists when gtm.js reads it. */
export function tagAssistantDebugCookieScript(): string {
  return `(function(){try{
var v=new URLSearchParams(location.search).get('gtm_debug');if(!v)return;
var ts=Number(v),now=Date.now();
if(ts<now+${MAX_FUTURE_MS}&&ts>now-${MAX_PAST_MS}){document.cookie='${COOKIE}=x; path=/; max-age=${MAX_AGE_S}; SameSite=Lax';}
}catch(e){}})();`;
}
